import * as React from 'react';

// Components
import Button from '../Button';
import Icon from '../Icon';
import Tooltip from '../Tooltip';

// Style
import './FixedFAB.css';

// Component
interface IProps {
  icon?: React.ReactNode;
  tooltipTitle?: string;
  onClick?: (e: React.MouseEvent<HTMLButtonElement | HTMLAnchorElement>) => void;
}

const FixedFAB = (props: IProps) => {
  const button = (
    <Button fab={true} color="secondary" onClick={props.onClick}>
      {props.icon ? props.icon : <Icon>add</Icon>}
    </Button>
  );
  return (
    <div className="FixedFAB mui-fixed">
      {props.tooltipTitle ? (
        <Tooltip title={props.tooltipTitle} placement="left">
          {button}
        </Tooltip>
      ) : (
        button
      )}
    </div>
  );
};

export default FixedFAB;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Layout/FixedFAB.tsx